var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","loading":_vm.isLoading},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.performSynchronization.apply(null, arguments)}}},[_c('span',{class:['glyphicon', 'glyphicon-refresh', {'spin': _vm.isLoading}]}),_vm._v("\n  "+_vm._s(_vm.$t('marker.ftp.synchronize'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }